/**
 Wraps text for a force-graph `nodeLabel`/`linkLabel`. float-tooltip, which renders those labels,
 sets a string through innerHTML, so a scraped name like `<img src=x onerror=…>` would run as
 script; an element is appended as-is, and its textContent is never parsed.
 */
export function textTooltip(text: string): HTMLElement {
  const span = document.createElement('span');
  span.textContent = text;
  return span;
}
